(function () {
  function $(sel, root = document) { return root.querySelector(sel); }
  function escapeHtml(s) {
    return (s || "").replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  }

  function ensureLoadingStyles() {
    if (document.getElementById('ps-predictive-search-loading-styles')) return;

    const style = document.createElement('style');
    style.id = 'ps-predictive-search-loading-styles';
    style.textContent = `
      .ps-search-suggest .ps-suggest-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        min-height: 58px;
        padding: 14px 16px;
        color: rgba(17,24,39,.72);
        font-size: 13px;
        font-weight: 600;
      }
      .ps-search-suggest .ps-suggest-loading__spinner {
        width: 16px;
        height: 16px;
        flex: 0 0 16px;
        border: 2px solid rgba(98,1,95,.18);
        border-top-color: #62015F;
        border-radius: 50%;
        animation: psPredictiveSearchSpin .65s linear infinite;
      }
      @keyframes psPredictiveSearchSpin {
        to { transform: rotate(360deg); }
      }
      @media (prefers-reduced-motion: reduce) {
        .ps-search-suggest .ps-suggest-loading__spinner { animation: none; }
      }
    `;
    document.head.appendChild(style);
  }

  function initOne(section) {
    const input = $(".ps-searchbar-input", section);
    const box = $(".ps-search-suggest", section);
    if (!input || !box) return;

    ensureLoadingStyles();

    const form = input.closest('form');
    const submitButton = form ? $('.ps-searchbar-btn', form) : null;
    const originalSubmitText = submitButton ? submitButton.textContent : '';

    let t = null;
    let last = "";
    let controller = null;
    let requestId = 0;

    function abortActiveRequest() {
      if (controller) {
        try { controller.abort(); } catch (e) {}
        controller = null;
      }
    }

    function clearLoadingState() {
      input.removeAttribute('aria-busy');
      box.removeAttribute('aria-busy');
      box.removeAttribute('data-loading');
    }

    function closeBox() {
      clearLoadingState();
      box.hidden = true;
      box.innerHTML = "";
    }

    function showLoading() {
      input.setAttribute('aria-busy', 'true');
      box.setAttribute('aria-busy', 'true');
      box.setAttribute('data-loading', 'true');
      box.innerHTML = `
        <div class="ps-suggest-loading" role="status" aria-live="polite">
          <span class="ps-suggest-loading__spinner" aria-hidden="true"></span>
          <span>Searching perfumes...</span>
        </div>
      `;
      box.hidden = false;
    }

    async function fetchSuggestions(q, signal) {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`;
      const res = await fetch(url, { credentials: "same-origin", signal });
      if (!res.ok) throw new Error(`Predictive search request failed (${res.status})`);
      return res.json();
    }

    function render(data) {
      const products = data?.resources?.results?.products || [];
      if (!products.length) { closeBox(); return; }

      const html = products.map(p => {
        const title = escapeHtml(p.title);
        const type = escapeHtml(p.product_type || "");
        const url = p.url;
        const img = p.image ? p.image : "";
        return `
          <a class="ps-suggest-item" href="${url}">
            <img class="ps-suggest-thumb" src="${img}" alt="${title}">
            <div>
              <div class="ps-suggest-title">${title}</div>
              ${type ? `<div class="ps-suggest-meta">${type}</div>` : ``}
            </div>
          </a>
        `;
      }).join("");

      clearLoadingState();
      box.innerHTML = html;
      box.hidden = false;
    }

    function scheduleSearch() {
      const q = input.value.trim();

      clearTimeout(t);

      if (q.length < 2) {
        last = "";
        requestId += 1;
        abortActiveRequest();
        closeBox();
        return;
      }

      // Do not duplicate a request/render while the same query is already visible.
      if (q === last && !box.hidden && box.getAttribute('data-loading') !== 'true') return;

      last = q;
      requestId += 1;
      const thisRequestId = requestId;

      // A new query immediately invalidates any older in-flight response.
      abortActiveRequest();
      showLoading();

      t = setTimeout(async () => {
        const localController = new AbortController();
        controller = localController;

        try {
          const data = await fetchSuggestions(q, localController.signal);

          // Only the newest request is allowed to render.
          if (thisRequestId !== requestId || input.value.trim() !== q) return;
          render(data);
        } catch (e) {
          if (e && e.name === 'AbortError') return;
          if (thisRequestId === requestId) closeBox();
          console.error('PS predictive search failed:', e);
        } finally {
          if (controller === localController) controller = null;
          if (thisRequestId === requestId && box.getAttribute('data-loading') === 'true') {
            clearLoadingState();
          }
        }
      }, 200);
    }

    input.addEventListener("input", scheduleSearch);

    input.addEventListener("focus", () => {
      const q = input.value.trim();
      if (q.length >= 2 && box.hidden) scheduleSearch();
    });

    document.addEventListener("click", (e) => {
      if (!section.contains(e.target)) {
        clearTimeout(t);
        requestId += 1;
        abortActiveRequest();
        closeBox();
      }
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        clearTimeout(t);
        requestId += 1;
        abortActiveRequest();
        closeBox();
      }
    });

    if (form) {
      form.addEventListener('submit', () => {
        clearTimeout(t);
        requestId += 1;
        abortActiveRequest();
        closeBox();
        input.setAttribute('aria-busy', 'true');

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.textContent = 'Searching...';
        }
      });

      window.addEventListener('pageshow', () => {
        input.removeAttribute('aria-busy');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
          submitButton.textContent = originalSubmitText;
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ps-searchbar]').forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
